import React, { useCallback } from "react";
import { ExpandSingle } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useTaskGroupHeaderNames } from "~/components/Hooks/tasks";

export const UserTaskGroupedByDateListItem = ({ collectionName, count, isExpanded, setExpanded }) => {
  const headerNames = useTaskGroupHeaderNames();

  const handleGroupChanged = useCallback(() => {
    setExpanded(collectionName);
  }, [collectionName, setExpanded]);

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-start grouped_by_header">
        <ExpandSingle
          expanded={isExpanded}
          onClick={handleGroupChanged}
          className="tw-mr-3 tw-cursor-pointer tw-text-theme-700"
        />
        <div
          className={classnames("group_by_date_name", {
            overdue: collectionName === "overdue",
          })}
        >
          {`${headerNames[collectionName]} (${count})`}
        </div>
      </div>
    </div>
  );
};

UserTaskGroupedByDateListItem.propTypes = {
  collectionName: PropTypes.string.isRequired,
  count: PropTypes.number,
  isExpanded: PropTypes.bool,
  setExpanded: PropTypes.func,
};
